import React from 'react'
import withCompany from 'components/withCompany'
import updateCompanyMutation from 'graphs/mutations/updateCompany.graphql'
import companyValidation from 'validations/company'
import FormForRecord from 'components/FormForRecord'
import fields from 'fields/companies'

const RouteEdit = ({ company, history: { goBack } }) => (
  <FormForRecord
    record={company}
    mutation={updateCompanyMutation}
    onSuccess={goBack}
    onCancel={goBack}
    fields={fields}
    variables={{ id: company.id }}
    schema={companyValidation}
    title="Edit Company Information"
  />
)

export default withCompany(RouteEdit)



// WEBPACK FOOTER //
// ./src/routes/admin/companies/edit.js